export default __webpack_public_path__ + "static/service-map-532ba6bff6e2f6c2d2a92f5d249f1d68.png";